<template>
    <div class="filter-wrapper" @scroll.stop="handleScrollLock"  @touchmove.stop="handleScrollLock">
        <div class="filter">
            <slot/>
        </div>
        <transition name="el-fade-in">
          <div class="mask" @touchmove.stop="handleScrollLock" v-if="mask" @click.stop="handleMaskClick"></div>
        </transition>
    </div>
</template>

<script>
import scrollLocker from '@/utils/scroll-lock'
export default {
  name: 'filters',
  props: {
    mask: Boolean
  },
  data () {
    return {
      showMask: false
    }
  },
  watch: {
    mask: {
      immediate: true,
      handler (val) {
        if (val) {
          scrollLocker.lock()
        } else {
          scrollLocker.unlock()
        }
      }
    }
  },
  methods: {
    handleMaskClick (e) {
      this.$emit('on-mask-click', e)
    },
    handleScrollLock (e) {
      e.stopPropagation()
      e.preventDefault()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variable.scss';
.filter-wrapper {
  .radio-selector-item {
    padding: 25px;
  }
    .filter {
        position: relative;
        display: flex;
        width: 100%;
        height: 60px;
        background: #F8F8F8;
        @include clearfix;
        z-index: 899;
        font-size: 0;
        &-item {
          position: relative;
          display: flex;
          flex: 1;
          width: 25%;
          height: 100%;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          color: $black_text;
          float: left;
          .jc-icon {
            display: inline-block;
            transition: transform .3s linear;
            &.reverse {
              transform: rotate(180deg);
            }
          }
          * {
            vertical-align: middle;
          }
          &.active {
            color: #409bff;
          }
        }
    }
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .4);
    height: 100%;
    z-index: 1;
  }
}
.fliter-item {
  i {
    display: inline-block;
    margin-left: 8px;
    transition: transform .2s linear;
    &.icon-filter {
      font-size: 24px;
    }
  }
  &.sorts {
    &.opened {
      i {
        transform: rotate(180deg);
      }
    }
  }
  * {
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/filters/filters.vue